<!-- 这里只有店铺退仓详情 -->
<template>
    <el-drawer size="90%" :visible.sync="dialogVisible" :wrapperClosable="false" @close="close" :show-close="false">
        <section slot="title" class="dialog-top">
            <p>{{ $t('invoicesCenter.deptretreatdetailsTitle') }}</p>
            <div style="display: flex">
                <div
                    class="sub-box"
                    @click="checkAcceptClick"
                    v-if="type == 2 && [4, 5].includes(+modalParams.state)"
                >
                    <svg-icon class-name="size-icon" icon-class="picking" /> {{ $t('invoicesCenter.deptretreatdetailsStartpicking') }}
                </div>
                <i class="el-icon-close" @click="dialogVisible = false"></i>
            </div>
        </section>
        <section v-loading="loading">
            <section class="step">
                <!-- <el-steps :active="scheduleState" finish-status="finish" process-status="wait" align-center>
                    <el-step
                        v-for="(item, index) in scheduleInfoList"
                        :key="item.sort"
                        :title="item.invoicesName"
                        :status="item.hasNowStep === 'N' ? 'wait' : ''"
                    >
                        <div slot="description" v-if="item.hasNowStep === 'Y'">
                            <div>{{ item.startTime }}</div>
                            <div v-if="item.consumingTime && index > 0" style="color: #999">
                                耗时：{{ item.consumingTime }}
                            </div>
                            <span v-if="item.timeout" style="color: red">超时：{{ item.overTime }}</span>
                        </div>
                    </el-step>
                </el-steps> -->
                <Timeline :timeList="scheduleInfoList"></Timeline>
            </section>
            <section class="section-card">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.deptretreatdetailsInvoiceinfotitle') }}</div>
                </h3>
                <div class="section-value" v-if="invoicesData">
                    <el-descriptions :column="4" size="small" border style="width: 100%">
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsCreator') }} </template>
                            {{ invoicesData.createUserName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsSender') }} </template>
                            {{ invoicesData.marketName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsReceiver') }} </template>
                            {{ invoicesData.warehouseName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsReturnquantity') }} </template>
                            {{ invoicesData.totalNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsOutboundquantity') }} </template>
                            {{ invoicesData.outNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsInboundquantity') }} </template>
                            {{ invoicesData.inNum }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsOutbounddiff') }} </template>
                            {{ invoicesData.outNumDifference || 0 }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsInbounddiff') }} </template>
                            <!-- {{ invoicesData.storageDifferenceCount }} -->
                            {{ invoicesData.inNumDifference || 0 }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsCreatetime') }} </template>
                            {{ invoicesData.createTime }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsUpdatetime') }} </template>
                            {{ invoicesData.updateTime }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsLastmodifier') }} </template>
                            {{ invoicesData.updateUserName }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsTotaltime') }} </template>
                            {{ invoicesData.totalTime }}
                        </el-descriptions-item>
                        <el-descriptions-item v-if="invoicesData.goodsPrincipal && drawerType != 2">
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsGoodsresponsible') }} </template>
                            {{ invoicesData.goodsPrincipal }}
                        </el-descriptions-item>
                        <el-descriptions-item>
                            <template slot="label"> {{ $t('invoicesCenter.deptretreatdetailsRemark') }} </template>
                            {{ invoicesData.remark }}
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
                <div class="detail-state" v-if="invoicesData">
                    <StatusTag v-if="invoicesData.state == 0" type="void" />
                    <StatusTag v-if="invoicesData.state == 4" type="sended" />
                    <StatusTag v-if="invoicesData.state == 5" type="orderpack" />
                    <StatusTag v-if="invoicesData.state == 6" type="orderpacked" />
                    <StatusTag v-if="invoicesData.state == 7" type="packing" />
                    <StatusTag v-if="invoicesData.state == 8" type="packed" />
                    <StatusTag v-if="invoicesData.state == 9" type="outed" />
                    <StatusTag v-if="invoicesData.state == 10" type="checked" />
                    <StatusTag v-if="invoicesData.state == 14" type="joined" />
                </div>
            </section>

            <section class="section-card">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.deptretreatdetailsGoodslisttitle') }}</div>
                </h3>
                <div>
                    <SizeGroupTable
                        ref="sizeGroupTableIns"
                        :dataList="dataList"
                        :columns="newColumns"
                        :isEmpty="true"
                        :sizeInfoLabels="newSizeInfoLabels"
                        :footerOptions="newFooterOptions"
                        border
                    >
                        <template v-slot="{ row, item }">
                            <el-popover v-if="item.prop === 'goodsNo'" placement="right-start" trigger="click">
                                <el-image
                                    v-if="row.imageList && row.imageList.length"
                                    style="width: 400px; height: 400px"
                                    :src="row.imageList[0]"
                                    :preview-src-list="row.imageList"
                                >
                                </el-image>
                                <span slot="reference" class="text-link">{{ row.goodsNo }} </span>
                            </el-popover>
                        </template>
                    </SizeGroupTable>
                </div>
            </section>
            <section class="section-card" v-if="logisticsList.length">
                <h3 class="section-title">
                    <span></span>
                    <div>{{ $t('invoicesCenter.deptretreatdetailsShipmentinfotitle') }}</div>
                </h3>
                <div style="margin: 20px">
                    <el-table
                        border
                        :data="logisticsList"
                        :header-cell-style="{
                            background: '#F3F4F7',
                            color: '#555',
                            padding: '5px 0'
                        }"
                        :cell-style="{ padding: '5px 0' }"
                        :span-method="arraySpanMethod">
                        <el-table-column prop="invoicesNo" :label="$t('invoicesCenter.deptretreatdetailsInvoiceno')" align="center"> </el-table-column>
                        <el-table-column prop="packageSn" :label="$t('invoicesCenter.deptretreatdetailsPackageno')" align="center"></el-table-column>
                        <el-table-column prop="goodsNum" :label="$t('invoicesCenter.deptretreatdetailsGoodsquantity')" align="center"></el-table-column>
                        <el-table-column prop="senderInfoName" :label="$t('invoicesCenter.deptretreatdetailsSenderinfo')" align="center"> </el-table-column>
                        <el-table-column prop="receiveInfoName" :label="$t('invoicesCenter.deptretreatdetailsReceiverinfo')" align="center"> </el-table-column>
                        <el-table-column prop="logisticsName" :label="$t('invoicesCenter.deptretreatdetailsLogisticscompany')" align="center"> </el-table-column>
                        <el-table-column prop="expressNo" :label="$t('invoicesCenter.deptretreatdetailsTrackingno')" align="center"> </el-table-column>
                        <el-table-column prop="state" :label="$t('invoicesCenter.deptretreatdetailsStatus')" align="center">
                          <template slot-scope="scope">
                            <el-tag effect="dark"
                                    v-if="scope.row.logisticsName && scope.row.logisticsName.indexOf('京东') !== -1">
                              {{ scope.row.jdStateDesc ? scope.row.jdStateDesc : $t('invoicesCenter.deptretreatdetailsPendingupdate') }}
                            </el-tag>
                            <el-tag effect="dark" v-else :type="expressState[scope.row.state].type">
                              {{ scope.row.stateDesc }}
                            </el-tag>
                          </template>
                        </el-table-column>
                      <el-table-column prop="packingTime" :label="$t('invoicesCenter.deptretreatdetailsPackingcompletetime')" align="center"  width="170"> </el-table-column>
                        <el-table-column prop="shipmentTime" :label="$t('invoicesCenter.deptretreatdetailsShipmenttime')" align="center"  width="170"> </el-table-column>
                        <el-table-column prop="signTime" :label="$t('invoicesCenter.deptretreatdetailsSigntime')" align="center"  width="170"> </el-table-column>
                        <el-table-column fixed="right" :label="$t('invoicesCenter.deptretreatdetailsActions')" width="220px" align="center">
                            <template slot-scope="scope" style="display: flex">
                                <div style="display: flex;flex-wrap: wrap;">
                                    <el-button @click="clickPackage(scope.row)" type="text" size="small" style="margin-left: 10px;">
                                      <span style="text-decoration: underline">{{ $t('invoicesCenter.deptretreatdetailsViewpackage') }}</span>
                                    </el-button>
                                    <el-button @click="handleClick(scope.row)" type="text" size="small">
                                        <span style="text-decoration: underline">{{ $t('invoicesCenter.deptretreatdetailsLogisticstrack') }}</span>
                                    </el-button>

                                    <el-button
                                        @click="amendClick(scope.row)"
                                        type="text"
                                        size="small"
                                        v-if="scope.row.expressNo && [1, 2].includes(+scope.row.state)"
                                    >
                                        <span style="text-decoration: underline">{{ $t('invoicesCenter.deptretreatdetailsEditinfo') }}</span>
                                    </el-button>
                                  <el-button @click="printClick(scope.row)" type="text" size="small">
                                    <span style="text-decoration: underline">{{ $t('invoicesCenter.deptretreatdetailsPrint') }}</span>
                                  </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </section>

            <section class="section-card" v-if="differList.length">
              <h3 class="section-title">
                <span></span>
                <div>{{ $t('invoicesCenter.deptretreatdetailsDiffinfotitle') }}</div>
              </h3>
              <div style="margin: 20px">
                <el-table
                    border
                    :data="differList"
                    :header-cell-style="{
                        background: '#F3F4F7',
                        color: '#555',
                        padding: '5px 0'
                      }"
                    :cell-style="{ padding: '5px 0' }">
                  <el-table-column prop="packageSn" :label="$t('invoicesCenter.deptretreatdetailsPackageno')" align="center"></el-table-column>
                  <el-table-column prop="receiveName" :label="$t('invoicesCenter.deptretreatdetailsConsignee')" align="center"></el-table-column>
                  <el-table-column prop="checkCompleteTime" :label="$t('invoicesCenter.deptretreatdetailsReceiptcompletetime')" align="center" width="200"></el-table-column>
                  <el-table-column prop="sendNum" :label="$t('invoicesCenter.deptretreatdetailsGoodsquantity')" align="center"></el-table-column>
                  <el-table-column prop="sendEpcNum" :label="$t('invoicesCenter.deptretreatdetailsOutboundlabelquantity')" align="center"></el-table-column>
                  <el-table-column prop="discrepancyNum" :label="$t('invoicesCenter.deptretreatdetailsDiscrepancy')" align="center"></el-table-column>
                  <el-table-column prop="sendDutyNum" :label="$t('invoicesCenter.deptretreatdetailsSenderresponsibility')" align="center"></el-table-column>
                  <el-table-column prop="receiveDutyNum" :label="$t('invoicesCenter.deptretreatdetailsReceiverresponsibility')" align="center"></el-table-column>
                  <el-table-column prop="transportDutyNum" :label="$t('invoicesCenter.deptretreatdetailsTransportresponsibility')" align="center"></el-table-column>
                  <el-table-column prop="state" :label="$t('invoicesCenter.deptretreatdetailsStatus')" align="center">
                    <template slot-scope="scope">
                      <el-tag
                          effect="dark"
                          size="mini"
                          :type="scope.row.state === '0' ? 'danger' : 'success'">
                        {{scope.row.state === '0' ? $t('invoicesCenter.deptretreatdetailsUndetermined') : $t('invoicesCenter.deptretreatdetailsDetermined')}}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column fixed="right" :label="$t('invoicesCenter.deptretreatdetailsActions')" width="150">
                    <template slot-scope="scope">
                      <el-button @click="showDifferDetail(scope.row)" type="text" size="small">
                        <span style="text-decoration: underline">{{ $t('invoicesCenter.deptretreatdetailsViewdetails') }}</span>
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </section>

            <section class="section-card" v-if="invoiceInvalidApplyInfoList.length">
              <h3 class="section-title">
                <span></span>
                <div>{{ $t('invoicesCenter.deptretreatdetailsCancelapplicationtitle') }}</div>
              </h3>
              <div style="margin: 20px;">
                <el-table
                    border
                    :data="invoiceInvalidApplyInfoList"
                    :header-cell-style="{
                                        background: '#F3F4F7',
                                        color: '#555',
                                        padding: '5px 0'
                                    }"
                    :cell-style="{ padding: '5px 0' }">
                  <el-table-column prop="applyUserName" :label="$t('invoicesCenter.deptretreatdetailsApplicant')" align="center" width="180"> </el-table-column>
                  <el-table-column prop="applyTime" :label="$t('invoicesCenter.deptretreatdetailsApplicationtime')" align="center" width="200"> </el-table-column>
                  <el-table-column prop="applyRemark" :label="$t('invoicesCenter.deptretreatdetailsApplicationreason')" align="center"> </el-table-column>
                  <el-table-column prop="state" :label="$t('invoicesCenter.deptretreatdetailsStatus')" align="center" width="180">
                    <template slot-scope="scope">
                      <el-tag
                          effect="dark"
                          :type="scope.row.state == '0' ? 'warning' : scope.row.state == '1' ? 'success' : 'danger'">
                        {{scope.row.state == '0' ? $t('invoicesCenter.deptretreatdetailsPendingapproval') : scope.row.state == '1' ? $t('invoicesCenter.deptretreatdetailsApproved') : $t('invoicesCenter.deptretreatdetailsRejected')}}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column prop="checkUserName" :label="$t('invoicesCenter.deptretreatdetailsApprover')" align="center" width="200"> </el-table-column>
                  <el-table-column prop="checkTime" :label="$t('invoicesCenter.deptretreatdetailsApprovaltime')" align="center" width="200"> </el-table-column>
                </el-table>
              </div>
            </section>
            <packageAndEpc
                v-if="packageModule"
                :detailList="detailLists"
                @close="packageModule = false"
            ></packageAndEpc>
            <differDetailDialog v-if="isShowDiffer" :differRows="differRows" @close="isShowDiffer = false" @updateDiffer="fetchDifferList"></differDetailDialog>
            <TrackDialog v-if="disloagModule" :expressNo="expressNo" @close="disloagModule = false"></TrackDialog>
            <ReturnPickUp v-if="type == 2 && CheckAcceptModule" :modalParams="modalParams" @close="checkClose" documentType="TCD"></ReturnPickUp>
            <printDeliveryOrder
                v-if="printDialog"
                @close="printDialog = false"
                type="2"
                :modalParams="rowData"
                :isPrint="false"
            ></printDeliveryOrder>
            <entryCourierInfo v-if="entryCourierDialog" invoiceType="TCD" :modalParams="modalParams" :updateInfo="details" @close="entryCourier"></entryCourierInfo>
            <el-dialog
                :append-to-body="true"
                :title="$t('invoicesCenter.deptretreatdetailsSelectpackagetitle')"
                :visible.sync="packDialogShow"
                width="20%"
                :before-close="packClose"
                custom-class="pack-dialog"
            >
                <el-select v-model="packageId" size="small" :placeholder="$t('invoicesCenter.deptretreatdetailsSelect')">
                    <el-option
                        v-for="item in packOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                        :disabled="item.state == 2"
                    >
                    </el-option>
                </el-select>
                <el-button type="primary" size="small" @click="packConfirm">{{ $t('invoicesCenter.deptretreatdetailsConfirm') }}</el-button>
            </el-dialog>
          <InvoicePrint
            v-if="packagePrintDialog"
            :modalParams="packageList"
            @close="packagePrintDialog = false"
          >
          </InvoicePrint>
        </section>
    </el-drawer>
</template>

<script>
import Timeline from '@/components/Timeline/index.vue'
import packageAndEpc from './packageEpcPh.vue'
import svgIcon from '@/components/SvgIcon/index'
import TrackDialog from '../../components/trackDialog.vue'
import differDetailDialog from '../../components/differDetailDialog'
import { erpPackageRecallJdExpress, queryIntoStockPackageList } from '@/libs/http/api.js'
import {
  erp2ErpMarketReturnQueryDetail,
  erp2OperatingInterceptExpress,
  queryDiscrepancyList
} from '@/libs/http/modules/erp.js'
import ReturnPickUp from './ReturnPickUp.vue'
import printDeliveryOrder from '../../components/printDeliveryOrder.vue'
import entryCourierInfo from '../../components/entryCourierInfo.vue'
import SizeGroupTable from '@/components/SizeGroupTable/index.vue'
import { columnObj, sizeInfoLabel, footerObj } from './tableConfig.js'
import InvoicePrint from "@/components/packagePrintInvoices/index.vue";

export default {
    name: 'ShopDetails',
    props: {
        modalParams: {
            type: Object,
            default: () => null
        },

        type: {
            type: String,
            default: '1'
        }
    },
    components: {
        TrackDialog,
        ReturnPickUp,
        printDeliveryOrder,
        differDetailDialog,
        entryCourierInfo,
        SizeGroupTable,
        packageAndEpc,
        svgIcon,
        Timeline,
        InvoicePrint,
        StatusTag: () => import('@/components/StatusTag/index.vue')
    },
    data() {
        return {
            columnObj,
            sizeInfoLabel,
            footerObj,
            dialogVisible: false,
            CheckAcceptModule: false,
            entryCourierDialog: false,
            drawerType: 1,
            details: [],
            headerLeft: [
                { key: 'goodsName', name: this.$t('invoicesCenter.deptretreatdetailsGoodsname'), type: 'ph' },
                { key: 'goodsNo', name: this.$t('invoicesCenter.deptretreatdetailsGoodsno') },
                { key: 'retailPrice', name: this.$t('invoicesCenter.deptretreatdetailsRetailprice') }
                // {key: 'salesPrice', name: '铺货价'}
            ],
            dataList: [],
            invoicesData: null,
            invoicesSnType: '',
            logisticsList: [],
            courierInfoDialog: false,
            scheduleInfoList: [],
            scheduleState: 1,
            disloagModule: false,
            rowData: null,
            printDialog: false,
            expressNo: null,
            packDialogShow: false,
            loading: false,
            packageId: '',
            packOptions: [],
            drawerModalParams: {},
            invoiceInvalidApplyInfoList:[],
            expressState: {
                0: {
                    type: 'warning',
                    label: this.$t('invoicesCenter.deptretreatdetailsNotcollected')
                },
                1: {
                    type: 'warning',
                    label: this.$t('invoicesCenter.deptretreatdetailsPendingshipment')
                },
                2: {
                    type: 'info',
                    label: this.$t('invoicesCenter.deptretreatdetailsIntransit')
                },
                3: {
                    type: '',
                    label: this.$t('invoicesCenter.deptretreatdetailsOutfordelivery')
                },
                4: {
                    type: 'success',
                    label: this.$t('invoicesCenter.deptretreatdetailsDelivered')
                }
            },
            differList: [],
            differRows: null,
            isShowDiffer: false,
            packageModule: false,
            detailLists: [],
            packagePrintDialog:false,
            packageList:[],
        }
    },
    computed: {
        newSizeInfoLabels() {
            return this.formatLabels(this.sizeInfoLabel['TC'])
        },
        newFooterOptions() {
            return this.footerObj['TC']
        },
        newColumns() {
            return this.columnObj['TC']
        }
    },
    mounted() {
        this.fetchDetail()
        this.fetchDifferList()
    },
    methods: {
        formatLabels(arr) {
            return arr.map((item, index) => {
                if (index === 0) {
                    item.disabled = false
                    item.value = this.scheduleState >= 1 ? true : false
                } else if ([1, 2].includes(index)) {
                    item.disabled = this.scheduleState >= 2 ? false : true
                    item.value = this.scheduleState >= 2 ? true : false
                } else if ([3, 4].includes(index)) {
                    item.disabled = this.scheduleState > 3 ? false : true
                    item.value = this.scheduleState > 3 ? true : false
                }
                return item
            })
        },
        checkClose(e) {
            this.CheckAcceptModule = false
            if (e) {
                this.fetchDetail()
            }
            this.$parent.refetch()
        },
        clickPackage(row) {
          this.packageModule = true
          this.detailLists = row
        },
        packageInfo(row) {
            this.printDialog = true
            row.invoicesId = this.modalParams.invoicesId
            this.rowData = row
        },
        close() {
            this.dialogVisible = false
            this.$emit('close')
        },
        checkAcceptClick() {
          if(this.modalParams['marketingRfidReturnSwitch'] === 'Y'){
            return this.$message({ type: 'error', message: this.$t('invoicesCenter.deptretreatdetailsUsepdaforpicking'), duration: 2000, showClose: true })
          }
          this.CheckAcceptModule = true
        },
        fetchDetail() {
            this.loading = true
            this.dialogVisible = true
            erp2ErpMarketReturnQueryDetail({
                id: this.modalParams.id
            })
                .then((data) => {
                    this.loading = false
                    this.invoicesData = data.invoicesInfo
                    this.invoicesSnType = data.invoicesInfo.invoicesSn.slice(0, 2) || 'PH'
                    this.$nextTick(() => {
                        this.dataList = data.goodsInfoList || []
                    })
                    this.invoiceInvalidApplyInfoList = data.invoiceInvalidApplyInfoList || []
                    this.logisticsList = data.logisticsList || []
                    this.scheduleInfoList = data.scheduleInfoList || []
                    this.scheduleState = Number(data.scheduleState)
                })
                .catch((err) => {
                    this.loading = false
                    this.$message({
                        type: 'error',
                        message: err,
                        duration: 2000,
                        showClose: true
                    })
                })
        },
        getSpanArr(data, spanKey) {
            let spanArr = [] //值
            let pos = '' //下标
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    spanArr.push(1)
                    pos = 0
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i][spanKey] === data[i - 1][spanKey]) {
                        spanArr[pos] += 1
                        spanArr.push(0)
                    } else {
                        spanArr.push(1)
                        pos = i
                    }
                }
            }
            return spanArr
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            let currindex = [0, 3, 4, 5, 6, 7, 9,10]
            if (currindex.indexOf(columnIndex) != -1) {
                let spanArr = this.getSpanArr(this.logisticsList, row.invoicesNo)
                const _row = spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        handleClick(row) {
            row.invoicesId = this.modalParams.invoicesId
            this.expressNo = row
            this.disloagModule = true
        },

        amendClick(row) {
            if (row.type == '1') {
                this.$confirm(this.$t('invoicesCenter.deptretreatdetailsConfirmcancelexpress'), {
                    type: 'warning'
                })
                    .then(() => {
                        erp2OperatingInterceptExpress({
                            id: row.packageId
                        })
                            .then((data) => {
                                this.$message.success(this.$t('invoicesCenter.deptretreatdetailsCancelsuccess'))
                                this.$nextTick(() => {
                                    this.fetchDetail()
                                })
                                this.entryCourierDialog = true
                              console.log(row.invoicesLogisticsInfoId)
                                this.details = { ...row, packageIds: [row.invoicesLogisticsInfoId] }
                            })
                            .catch((err) => {
                                this.$message({
                                    type: 'error',
                                    message: err,
                                    duration: 2000,
                                    showClose: true
                                })
                            })
                    })
                    .catch(() => {})
            }
            if (row.type == '2') {
                this.entryCourierDialog = true
                const list = this.logisticsList.map(item=>{
                  return item.packageId
                })
                this.details = { ...row, packageIds: list }
            }
        },
        entryCourier(refetch) {
            this.entryCourierDialog = false
            if (refetch) {
                this.fetchDetail()
            }
        },

        checkGet() {
            if (this.type == 1) {
                this.getPackOptions()
            } else {
                this.CheckAcceptModule = true
            }
        },
        packClose() {
            this.packDialogShow = false
            this.packageId = ''
        },
        packConfirm() {
            if (!this.packageId) {
                this.$message.error(this.$t('invoicesCenter.deptretreatdetailsSelectpackageno'))
                return
            }
            this.CheckAcceptModule = true
            this.drawerModalParams = { packageId: this.packageId }
            this.packClose()
        },
        getPackOptions() {
            let params = {
                invoicesId: this.modalParams.invoicesId,
                receiverType: '1'
            }
            queryIntoStockPackageList(params)
                .then((res) => {
                    if (res && res.items) {
                        if (res.items.length === 1) {
                            this.CheckAcceptModule = true
                            this.drawerModalParams = { packageId: res.items[0].packageId }
                            this.packClose()
                        } else if (res.items.length > 1) {
                            this.packOptions = res.items.map((i) => ({
                                label: i.packageNo,
                                value: i.packageId,
                                state: i.state
                            }))
                            this.packDialogShow = true
                        }
                    }
                })
                .catch((rej) => {
                    this.$message.error(rej)
                })
        },

        fetchDifferList(){
          queryDiscrepancyList({
            page: '1',
            pageSize: '100',
            queryText: this.modalParams.sn
          }).then(res=>{
            console.log(res)
            this.differList = res.items || []
          }).catch(error=>{})
        },
        showDifferDetail(row){
          this.differRows = row
          this.isShowDiffer = true
        },
      printClick(row) {
        this.packagePrintDialog=true
        row.sn=this.modalParams.sn
        this.packageList=[row]
      },

    }
}
</script>

<style lang="scss" scoped>
.dialog-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    p {
        font-size: 18px;
        color: #333;
    }

    div i {
        cursor: pointer;
        font-size: 22px;
        margin-left: 20px;
        float: right;
        margin-top: 8px;
    }

    .sub-box {
        color: black;
        margin: 10px 15px;
        padding: 10px 50px;
        background: #c6e7ff;
        display: flex;
        justify-content: center;
        align-content: center;
        cursor: pointer;
        border-radius: 3px;

        img {
            width: 20px;
            margin-right: 10px;
        }
    }
}

.step {
    width: 100%;
    padding-bottom: 50px;
}

.section-card {
    position: relative;
    margin-bottom: 30px;
    .text-link {
        color: #1890ff;
        cursor: pointer;
    }

    .section-title {
        font-size: 18px;
        color: #333;
        font-weight: normal;
        display: flex;
        align-items: center;

        span {
            margin-top: -2px;
            width: 4px;
            height: 18px;
            background: #067cf2;
            margin-right: 16px;
            border-radius: 0 2px 2px 0;
        }
    }

    > div {
        margin: 20px;
    }

    .detail-state {
        position: absolute;
        right: 20px;
        top: -50px;

        img {
            width: 80px;
        }
    }

    .section-value {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;

        > div {
            width: calc(100% / 3);
            margin-bottom: 10px;
        }
    }
}

.size-icon {
    margin-right: 5px;
    margin-top: 3px;
}
</style>
